export const styleGuide = {
  path: '/styleguide',
  name: 'styleguide',
  component: () => import('@/pages/StyleGuide/StyleGuide.vue'),
  meta: {
    layout: 'empty',
    title: 'Стайлгайд',
  },
  children: [
    {
      path: 'styles',
      name: 'StyleVariables',
      component: () => import('@/pages/StyleGuide/styles/StyleVariables.vue'),
      meta: {
        title: 'СSS переменные',
        section: 'styleguide',
      },
    },
    {
      path: 'base-input-text',
      name: 'StyleGuideBaseInputText',
      component: () =>
        import('@/pages/StyleGuide/baseInputText/StyleGuideBaseInputText.vue'),
      meta: {
        title: 'Инпут text',
        section: 'styleguide',
      },
    },
    {
      path: 'base-input-number',
      name: 'StyleGuideBaseInputNumber',
      component: () =>
        import('@/pages/StyleGuide/baseInputNumber/StyleGuideBaseInputNumber.vue'),
      meta: {
        title: 'Инпут number',
        section: 'styleguide',
      },
    },
    {
      path: 'base-otp-input',
      name: 'StyleGuideBaseOTPInput',
      component: () =>
        import('@/pages/StyleGuide/baseOTPInput/StyleGuideBaseOTPInput.vue'),
      meta: {
        title: 'Инпут одноразовый код-пароль',
        section: 'styleguide',
      },
    },
    {
      path: 'base-select',
      name: 'StyleGuideBaseSelect',
      component: () =>
        import('@/pages/StyleGuide/baseSelect/StyleGuideBaseSelect.vue'),
      meta: {
        title: 'Селект',
        section: 'styleguide',
      },
    },
    {
      path: 'base-multiselect',
      name: 'StyleGuideBaseMultiSelect',
      component: () =>
        import('@/pages/StyleGuide/baseMultiSelect/StyleGuideBaseMultiSelect.vue'),
      meta: {
        title: 'Мультиселект',
        section: 'styleguide',
      },
    },
    {
      path: 'base-button',
      name: 'StyleGuideBaseButton',
      component: () =>
        import('@/pages/StyleGuide/baseButton/StyleGuideBaseButton.vue'),
      meta: {
        title: 'Кнопка',
        section: 'styleguide',
      },
    },
    {
      path: 'base-checkbox',
      name: 'StyleGuideBaseCheckbox',
      component: () =>
        import('@/pages/StyleGuide/baseCheckbox/StyleGuideBaseCheckbox.vue'),
      meta: {
        title: 'Чекбокс',
        section: 'styleguide',
      },
    },
    {
      path: 'base-switch',
      name: 'StyleGuideBaseSwitch',
      component: () =>
        import('@/pages/StyleGuide/baseSwitch/StyleGuideBaseSwitch.vue'),
      meta: {
        title: 'Переключатель',
        section: 'styleguide',
      },
    },
    {
      path: 'base-switch-text',
      name: 'StyleGuideBaseSwitchText',
      component: () =>
        import(
          '@/pages/StyleGuide/baseSwitchText/StyleGuideBaseSwitchText.vue'
        ),
      meta: {
        title: 'Переключатель с текстом',
        section: 'styleguide',
      },
    },
    {
      path: 'base-arrow-toggle-button',
      name: 'StyleGuideBaseArrowToggleButton',
      component: () =>
        import(
          '@/pages/StyleGuide/baseArrowToggleButton/StyleGuideBaseArrowToggleButton.vue'
        ),
      meta: {
        title: 'Кнопка стрелка',
        section: 'styleguide',
      },
    },
    {
      path: 'base-color-picker',
      name: 'StyleGuideBaseColorPicker',
      component: () =>
        import(
          '@/pages/StyleGuide/baseColorPicker/StyleGuideBaseColorPicker.vue'
        ),
      meta: {
        title: 'Выбор цвета',
        section: 'styleguide',
      },
    },
    {
      path: 'base-tooltip',
      name: 'StyleGuideBaseTooltip',
      component: () =>
        import(
          '@/pages/StyleGuide/baseTooltip/StyleGuideBaseTooltip.vue'
        ),
      meta: {
        title: 'Тултип',
        section: 'styleguide',
      },
    },
    {
      path: 'base-progress-bar',
      name: 'StyleGuideBaseProgressBar',
      component: () =>
        import(
          '@/pages/StyleGuide/baseProgressBar/StyleGuideBaseProgressBar.vue'
        ),
      meta: {
        title: 'Индикатор прогресса',
        section: 'styleguide',
      },
    },
    {
      path: 'base-textarea',
      name: 'StyleGuideBaseTextarea',
      component: () =>
        import(
          '@/pages/StyleGuide/baseTextarea/StyleGuideBaseTextarea.vue'
        ),
      meta: {
        title: 'Текстареа',
        section: 'styleguide',
      },
    },
    {
      path: 'base-alert',
      name: 'StyleGuideBaseAlert',
      component: () =>
        import(
          '@/pages/StyleGuide/baseAlert/StyleGuideBaseAlert.vue'
        ),
      meta: {
        title: 'Алерт',
        section: 'styleguide',
      },
    },
    {
      path: 'base-range-input',
      name: 'StyleGuideBaseRangeInput',
      component: () =>
        import(
          '@/pages/StyleGuide/baseRangeInput/StyleGuideBaseRangeInput.vue'
        ),
      meta: {
        title: 'range-input',
        section: 'styleguide',
      },
    },
    {
      path: 'date-range-picker',
      name: 'StyleGuideBaseDateRangePicker',
      component: () =>
        import(
          '@/pages/StyleGuide/baseDateRangePicker/StyleGuideBaseDateRangePicker.vue'
        ),
      meta: {
        title: 'date-range-picker',
        section: 'styleguide',
      },
    },
    {
      path: 'date-range-picker-mobile',
      name: 'StyleGuideBaseDateRangePickerMobile',
      component: () =>
        import(
          '@/pages/StyleGuide/baseDateRangePickerMobile/StyleGuideBaseDateRangePickerMobile.vue'
        ),
      meta: {
        title: 'date-range-picker-mobile',
        section: 'styleguide',
      },
    },
  ]
}
